import { getUnitProperty, isBackendUnit } from '../../schemas/unitSchema';

export const calculateDashboardStatistics = (dashboardUnitsProcessed) => {
  if (!dashboardUnitsProcessed || dashboardUnitsProcessed.length === 0) {
    return {
      totalDailyUses: 0,
      averageDailyUptime: 0,
      activeUnitsCount: 0,
      activeUnitsWithErrors: 0,
      activeUnitsWithoutErrors: 0,
      issuesCount: 0,
      disabledUnitsCount: 0,
      disconnectedUnitsCount: 0,
      totalUnitsCount: 0,
    };
  }

  let usesCounter = 0;
  let dailyUptimeSum = 0;
  let activeUnitsCount = 0;
  let activeUnitsWithErrors = 0;
  let activeUnitsWithoutErrors = 0;
  let issuesCount = 0;
  let disabledUnitsCount = 0;
  let disconnectedUnitsCount = 0;

  dashboardUnitsProcessed.forEach(unit => {
    if (isBackendUnit(unit) === false) {
      const dailyUse = getUnitProperty(unit, 'daily_unit_use', 0);
      usesCounter += dailyUse || 0;
      
      const unitStatus = getUnitProperty(unit, 'unit_status');
      const isUnitDisconnected = getUnitProperty(unit, 'isUnitDisconnected', false);
      const hasErrors = getUnitProperty(unit, 'hasErrors', false);
      
      if (isUnitDisconnected) {
        // Disconnected units (regardless of their unit_status)
        disconnectedUnitsCount++;
      } else if (unitStatus === 'disabled') {
        // Disabled units that are connected
        disabledUnitsCount++;
      } else if (unitStatus === 'active') {
        // Active and connected units
        activeUnitsCount++;
        
        if (hasErrors) {
          activeUnitsWithErrors++;
        } else {
          activeUnitsWithoutErrors++;
        }
        
        // Calculate uptime only for active units
        const dailyUptime = getUnitProperty(unit, 'dailyUptime', 0);
        const uptimeValue = typeof dailyUptime === 'number' 
          ? dailyUptime 
          : (dailyUptime === "-" ? 0 : parseFloat(dailyUptime) || 0);
        dailyUptimeSum += uptimeValue;
      }
      
      // Count total issues (for other purposes)
      if (hasErrors) {
        issuesCount++;
      }
    }
  });

  const totalUnitsCount = activeUnitsCount + disabledUnitsCount + disconnectedUnitsCount;

  const averageDailyUptime = activeUnitsCount > 0
    ? Math.round((dailyUptimeSum / activeUnitsCount / 86400) * 100)
    : 0;

  return {
    totalDailyUses: usesCounter,
    averageDailyUptime,
    activeUnitsCount,
    activeUnitsWithErrors,
    activeUnitsWithoutErrors,
    issuesCount,
    disabledUnitsCount,
    disconnectedUnitsCount,
    totalUnitsCount,
  };
};